import React from "react";
import { Route } from "react-router-dom";
import * as T from "../utilities/frontendTypes";
import QueryBoundary from "../Components/QueryBoundary";

const AllAssessments = React.lazy(() => import("../Pages/IpExpertPages/AllAssessments"));
const FounderAssesments = React.lazy(() => import("../Pages/IpExpertPages/FounderAssesments"));
const FounderAssesmentDetails = React.lazy(() => import("../Pages/IpExpertPages/FounderAssesmentDetails"));
const InProgress = React.lazy(() => import("../Pages/IpExpertPages/InProgress"));
const Submitted = React.lazy(() => import("../Pages/IpExpertPages/Submitted"));
const SubmittedFounderAssesmentDetails = React.lazy(() => import("../Pages/IpExpertPages/SubmittedFounderAssesmentDetails"));
const DueDilligence = React.lazy(() => import("../Pages/IpExpertPages/DueDilligence"));

const LazyRoute = QueryBoundary;

interface ExpertRoutesProps {
  roleCheck: (roles: T.UserRole[], element: JSX.Element) => JSX.Element;
}

export function expertRoutes({
  roleCheck
}: ExpertRoutesProps) {
  return (
    <>
      <Route path="all-assessments" element={roleCheck(["ipExpert"], <LazyRoute><AllAssessments /></LazyRoute>)} />
      <Route path="expert-assessments" element={roleCheck(["ipExpert"], <LazyRoute><FounderAssesments /></LazyRoute>)} />
      <Route path="expert-assessments/:id" element={<LazyRoute><FounderAssesmentDetails /></LazyRoute>} />
      <Route path="in-progress-assesments" element={roleCheck(["ipExpert"], <LazyRoute><InProgress /></LazyRoute>)}>
        <Route path=":id" element={<LazyRoute><FounderAssesmentDetails /></LazyRoute>} />
      </Route>
      <Route path="submitted-assesments" element={roleCheck(["ipExpert"], <LazyRoute><Submitted /></LazyRoute>)}>
        <Route path=":id" element={<LazyRoute><SubmittedFounderAssesmentDetails /></LazyRoute>} />
      </Route>
      <Route path="in-dd-assesments" element={roleCheck(["ipExpert"], <LazyRoute><DueDilligence /></LazyRoute>)} />
    </>
  );
}
